<template>
  <v-tabs v-model="tab" class="elevation-3">
    <v-tab href="#vacations">{{ $t('REQUEST_VACATIONS.ITEMS') }}</v-tab>
    <v-tab href="#holidays">{{ $t('HOLIDAY.ITEMS') }}</v-tab>
    <v-tab-item value="vacations">
      <conflicts :items="vacationsTasks" :type="vacationType" />
    </v-tab-item>
    <v-tab-item value="holidays">
      <conflicts :items="holidaysTasks" :type="holidayType" />
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { DashboardService } from '@/services/dashboard.service';
import {
  HOLIDAYS,
  VACATIONS
} from '@/modules/statistic/components/Scheduling/Conflicts/ConflictsList';

export default {
  name: 'SchedulingConflicts',
  components: {
    Conflicts: () =>
      import('@/modules/statistic/components/Scheduling/Conflicts/Conflicts')
  },

  data: () => ({
    holidayType: HOLIDAYS,
    vacationType: VACATIONS,
    tab: null,
    holidaysTasks: [],
    vacationsTasks: []
  }),

  mounted() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      this.getHolidays();
      this.getVacations();
    },

    getVacations() {
      DashboardService.getRequestVacationConflicts()
        .then(({ data }) => {
          this.vacationsTasks = data.data;
        })
        .catch(error => {
          console.log('Error', error.message);
        });
    },
    getHolidays() {
      DashboardService.getRequestHolidayConflicts()
        .then(({ data }) => {
          this.holidaysTasks = data.data;
        })
        .catch(error => {
          console.log('Error', error.message);
        });
    }
  }
};
</script>

<style scoped></style>
